import React from 'react';
import { mainMapViewLabel, type MainMapView } from './mapUtils';

/**
 * Barre de contexte — habillage repris du prototype (`.ctxbar`) : 34 px, dégradé
 * sombre, chemin `Ops › <vue>` à gauche, compteurs de salle à droite.
 */

export const CTXBAR_HEIGHT = 34;

interface ContextBarProps {
  opsView: MainMapView;
  drawerView: MainMapView | null;
  waitingCount: number;
  activeCount: number;
  availableVehicles: number;
  availablePersonnel: number;
  onCloseDrawer: () => void;
}

const stat = (color: string): React.CSSProperties => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  borderRadius: 4,
  padding: '1px 7px',
  fontSize: 10,
  fontWeight: 700,
  border: `1px solid ${color}33`,
  color,
});

const ContextBar: React.FC<ContextBarProps> = ({
  opsView,
  drawerView,
  waitingCount,
  activeCount,
  availableVehicles,
  availablePersonnel,
  onCloseDrawer,
}) => (
  <div
    className="flex items-center justify-between gap-3 px-3"
    style={{
      height: CTXBAR_HEIGHT,
      flex: `0 0 ${CTXBAR_HEIGHT}px`,
      background: 'linear-gradient(180deg,#101a2b,#0b1320)',
      borderBottom: '1px solid #223046',
    }}
  >
    <div className="flex min-w-0 items-center gap-2" style={{ fontSize: 11 }}>
      <span
        style={{ fontSize: 9, letterSpacing: '.08em', color: '#6b7d95', background: '#172234', borderRadius: 3, padding: '1px 6px' }}
        className="uppercase"
      >
        Ops
      </span>
      <span style={{ color: '#dce5f2', fontWeight: 600 }}>{mainMapViewLabel(opsView)}</span>
      {drawerView ? (
        <>
          <span style={{ color: '#3f4f66' }}>›</span>
          <span
            style={{ fontSize: 9, letterSpacing: '.08em', color: '#a78bfa', background: '#241c40', borderRadius: 3, padding: '1px 6px' }}
            className="uppercase"
          >
            Gestion
          </span>
          <span style={{ color: '#c4b5fd', fontWeight: 600 }}>{mainMapViewLabel(drawerView)}</span>
          <button
            type="button"
            onClick={onCloseDrawer}
            style={{ fontSize: 10, color: '#9fb0c6', border: '1px solid #223046', background: '#172234', borderRadius: 4, padding: '0 6px' }}
            className="hover:brightness-125"
          >
            Fermer (Échap)
          </button>
        </>
      ) : null}
    </div>

    <div className="flex shrink-0 items-center gap-1.5">
      <span style={stat(waitingCount > 0 ? '#ef4444' : '#6b7d95')} title="Interventions en attente">
        {waitingCount} en attente
      </span>
      <span style={stat('#f59e0b')} title="Interventions en cours">
        {activeCount} en cours
      </span>
      <span style={stat('#10b981')} title="Engins disponibles">
        🚒 {availableVehicles}
      </span>
      <span style={stat('#38bdf8')} title="Agents disponibles">
        👤 {availablePersonnel}
      </span>
    </div>
  </div>
);

export default ContextBar;
